<div class="hls-player">
  <video #video
         class="hls-player__video"
         [hidden]="uiState !== 'ready'"
         controls
         playsinline
         [attr.aria-label]="'hlsPlayer.videoLabel' | transloco"
         (play)="onVideoPlayEvent()"
         (playing)="onVideoPlaying()"
         (error)="onNativeVideoError()"
  ></video>

  <!-- Duplo-clique/duplo-toque em qualquer ponto do overlay (não só no botão) nunca pode
       borbulhar até .ig-card__media: ela escuta (dblclick) e (touchend) pra curtir por
       double-tap (review B3, resíduo). Mesmo idioma dos botões de navegação do carrossel
       (.ig-card__nav, mais abaixo neste template), que já se protegem da mesma camada. -->
  <div class="hls-player__overlay"
       *ngIf="uiState !== 'ready'"
       (dblclick)="$event.stopPropagation()"
       (touchend)="$event.stopPropagation()">
    <ng-container [ngSwitch]="uiState">
      <div class="hls-player__state" *ngSwitchCase="'processing'">
        <p-progressSpinner [style]="{ width: '28px', height: '28px' }" strokeWidth="4"></p-progressSpinner>
        <span class="hls-player__message">{{ 'hlsPlayer.processing' | transloco }}</span>
        <ng-container *ngIf="stalled">
          <span class="hls-player__hint">{{ 'hlsPlayer.stillProcessing' | transloco }}</span>
          <button type="button" class="hls-player__action" (click)="retry(); $event.stopPropagation()">
            {{ 'hlsPlayer.refresh' | transloco }}
          </button>
        </ng-container>
      </div>

      <div class="hls-player__state" *ngSwitchCase="'failed'">
        <i class="pi pi-exclamation-triangle hls-player__icon"></i>
        <span class="hls-player__message">{{ 'hlsPlayer.failed' | transloco }}</span>
        <button type="button" class="hls-player__action" *ngIf="canRetry" (click)="retry(); $event.stopPropagation()">
          {{ 'hlsPlayer.retry' | transloco }}
        </button>
      </div>

      <div class="hls-player__state" *ngSwitchCase="'unsupported'">
        <i class="pi pi-ban hls-player__icon"></i>
        <span class="hls-player__message">{{ 'hlsPlayer.unsupported' | transloco }}</span>
      </div>
    </ng-container>
  </div>
</div>
